export const getCSRFToken = () =>
  document.querySelector("meta[name=csrf-token]")?.content

export async function saveScript(id, { source }) {
  const path = id ? `/embedded_scripts/${id}` : "/embedded_scripts"
  const body = JSON.stringify({ embedded_script: { source } })
  const headers = {
    Accept: "application/json",
    "X-CSRF-Token": getCSRFToken(),
    "Content-Type": "application/json"
  }
  const response = await fetch(path, {
    method: id ? "PUT" : "POST",
    headers,
    body
  })

  if (!response.ok) {
    throw new Error("Failed to save script", {
      cause: response.data.error || response.response
    })
  }
  const result = await response.json()

  return result
}

export async function getScript(id) {
  const response = await fetch(`/embedded_scripts/${id}`)

  if (!response.ok) {
    throw new Error("Failed to get script", {
      cause: response.data.error || response.response
    })
  }

  return response.text()
}
